module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"chartHeaderTooltip":"Wykres prezentuje wartości dla ceny minimalnej i maksymalnej oraz odchylenia względem ceny średniej."}}')
  delete Component.options._Ctor
}
